import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LocationStrategy, PathLocationStrategy, DatePipe, APP_BASE_HREF } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfigService } from 'src/app/common/service/app.config.service';
import { environment } from '../environments/environment';
import { Globals } from './globals';
import { ApiEndPoints } from './api-end-points';
import { NgIdleModule } from '@ng-idle/core';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { AuthGuard } from './login/auth.guard';
import { File } from "@awesome-cordova-plugins/file/ngx";
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { LoaderComponent } from 'src/app/global-loader/loader.component';
import { LoaderService } from 'src/app/global-loader/loader.service';
import { LoaderInterceptor } from 'src/app/global-loader/loader-interceptor-service';
import { ProgressSpinnerModule }  from 'primeng/progressspinner';
import { BnNgIdleService } from 'bn-ng-idle';
import { CleverTap } from '@ionic-native/clevertap/ngx';
import { CustomHttpInterceptor } from './http-interceptors/custom-http-interceptor';
import { OAuth2TokenService } from './common/service/oauth2-token.service';

@NgModule({
  declarations: [AppComponent,LoaderComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgIdleModule.forRoot(),
    BackButtonDisableModule.forRoot({preserveScrollPosition: true}),
    IonicModule.forRoot(),
    ProgressSpinnerModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    AuthGuard,
    Globals,
    ApiEndPoints,OAuth2TokenService,
    DatePipe,File,FileOpener,BnNgIdleService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },ConfigService,
    { provide: APP_BASE_HREF, useValue: '/' + new Globals().App_Context },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    LoaderService,
    // { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    CleverTap
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
